"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutreachService = void 0;
class OutreachService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Create a new outreach flow.
     * @param requestBody
     * @returns CreateResponse
     * @throws ApiError
     */
    createOutreachFlow(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/outreach',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get all outreach flows
     * @returns GetOutreachFlowsResponse
     * @throws ApiError
     */
    getOutreachFlows() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/outreach',
        });
    }
    /**
     * Duplicate outreach flow with its email policies
     * @param id
     * @param requestBody
     * @returns CreateResponse
     * @throws ApiError
     */
    duplicateOutreachFlow(id, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/outreach/{id}/duplicate',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get outreach flow.
     * @param id
     * @returns GetOutreachFlowResponse
     * @throws ApiError
     */
    getOutreachFlow(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/outreach/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * update outreach flow
     * @param id
     * @param requestBody UpdateOutreachFlowPayload
     * @returns any Successful response
     * @throws ApiError
     */
    updateOutreachFlow(id, requestBody) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/outreach/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * delete outreach flow
     * @param id
     * @returns any Successful response
     * @throws ApiError
     */
    deleteOutreachFlow(id) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/outreach/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Create a new flow email policy
     * @param flowId
     * @param requestBody CreateOutreachEmailPolicyPayload
     * @returns CreateResponse
     * @throws ApiError
     */
    createOutreachEmailPolicy(flowId, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/outreach/{flowId}/policy',
            path: {
                'flowId': flowId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete a flow email policy
     * @param flowId
     * @param id
     * @returns any Successful response
     * @throws ApiError
     */
    deleteOutreachEmailPolicy(flowId, id) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/outreach/{flowId}/policy/{id}',
            path: {
                'flowId': flowId,
                'id': id,
            },
        });
    }
    /**
     * Get a flow email policy
     * @param flowId
     * @param id
     * @returns GetOutreachFlowEmailPolicyResponse
     * @throws ApiError
     */
    getOutreachEmailPolicy(flowId, id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/outreach/{flowId}/policy/{id}',
            path: {
                'flowId': flowId,
                'id': id,
            },
        });
    }
    /**
     * Update a flow email policy
     * @param flowId
     * @param id
     * @param requestBody
     * @returns any Successful response
     * @throws ApiError
     */
    updateOutreachEmailPolicy(flowId, id, requestBody) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/outreach/{flowId}/policy/{id}',
            path: {
                'flowId': flowId,
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get a all flow email policy
     * @param flowId
     * @returns GetAllOutreachFlowEmailPoliciesResponse
     * @throws ApiError
     */
    getAllOutreachEmailPolicies(flowId) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/outreach/{flowId}/policies',
            path: {
                'flowId': flowId,
            },
        });
    }
    /**
     * Get list of sequences from mixmax
     * @returns MixmaxSequencesResponse
     * @throws ApiError
     */
    getMixmaxSequences() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/outreach/mixmax/sequences',
        });
    }
}
exports.OutreachService = OutreachService;
